export enum PharmacyChannel {
  CREATE = 'pharmacy::create',
  EDIT = 'pharmacy::patch',
  DELETE = 'pharmacy::delete',
}
